<template>
    <div class="article">
        <div class="article-wrap">
            <div class="banner">
                <div class="title">最新文章</div>
            </div>
            <div class="article-list container">
                <article-list-item v-for="(article, index) in articleList" :key="index" :dataId="article.id" :cover="article.cover" :title="article.title" :tags="article.tags">
                </article-list-item>
            </div>
        </div>
    </div>
</template>

<script>
import ArticleListItem from '@/components/officailPage/article/articleListItem.vue';

export default {
    mounted () {
        this.$analytics.logEvent("文章", {
            screen_name: "文章"
        });
    },
    components: {
        ArticleListItem
    },
    data () {
        return {
            articleList: [
                {
                    id: 6,
                    cover: 'https://flypig-public.s3-ap-southeast-1.amazonaws.com/images/landingPage/article_6.jpeg',
                    title: '租房可以換鎖嗎？是否該給房東一份備用鑰匙',
                    tags: ['租房', '換鎖', '鑰匙', '房東', '租客'],
                    content: ['近期透過友人分享實際發生的案例，一天半夜隔壁房的洗衣機水管突然爆裂，陽台開始積水，水也不停從陽台往下流，像是瀑布一樣的聲響引起整條巷子的人查看，偏偏隔壁房客又出遠門，友人眼看水也開始往自己的陽台流過來，只差一公分的高度就會流進房間，只好大半夜趕緊打給房屋代管人求救，房屋代管人一到，只能無奈身上也沒有鑰匙，半夜的屋主媽媽也沒接電話，但在下去也不行，若水一直流下去，明天整棟公寓大家都沒水用，於是代管人只能硬著頭皮去附近屋主媽媽家敲門拿備用鑰匙，才解決了這個半夜驚魂。']
                },
                {
                    id: 5,
                    cover: 'https://flypig-public.s3-ap-southeast-1.amazonaws.com/images/landingPage/article_5.jpeg',
                    title: '全台租金10年不減，租屋族的未來在哪裡',
                    tags: ['租屋', '租金', '房價', '租屋需求', '買房'],
                    content: ['現代年輕人，只要談到買房，總會出現心有餘而力不足的無奈，這居高不下的房價，讓多少年輕人寧願當個租屋族也不願犧牲生活品質買房，但談到租金，近年來也一直沒有下滑的的趨勢，每個月大筆大筆的租金繳出去，也得不到心中的踏實感，年輕人不禁心中自問，到底未來在哪裡？','根據主計總處公布每月租金報告顯示，國內租金自民國100年3月後，至去年底為止，只有在103年11月、12月是持平，其他都是每月上漲。雖在2020年初新冠疫情爆發後，聽到許多房東打出降低房租優惠要與租屋族們一起共體時艱，但從10年統計數據看起來，租金仍沒有下滑，對年輕人來說真的是很絕望，多少年輕人出外打拼為的就是要飛黃騰打，但現實就是高房價讓有錢人繼續買房，租屋族只能繼續租房。','租金不減的情況下，大部分外出打拼租屋族選擇房屋時，仍希望能在合理租金範圍內維持著好的生活水平，為的就是一個家的感覺，因此對於租屋條件也開始會下修，例如：即使繁華的大台北區域找到價格較低的套房或雅房，但那家徒四壁的小坪數只會讓租屋族更沮喪，因此寧可每天多花些通勤時間，選擇居住於相同低廉租金但坪數大一點的新北蛋白區。可是漸漸地又可以發現蛋白區的租金需求增加，價格競爭下，租金也悄悄漲了起來，租屋族就只能在下修租屋條件，繼續在這種低壓的惡性循環中求生存。','多少年輕人希望政府能協助，看得出政府這些年也一直在推出各種租屋條款，為的就是要協助無殼蝸牛族群，但或許真正的原因不是規範房東或者租屋津貼補助，若政府可以分散各縣市的就業機會，讓租屋需求不要那麼的集中，降低租金價格的競爭，就可以維持合理的租金價格，於此同時，也可以減少有錢人繼續炒房的機會，慢慢的把房市裡低氣壓的惡性循環帶往更好的發展。']
                },
                {
                    id: 4,
                    cover: 'https://flypig-public.s3-ap-southeast-1.amazonaws.com/images/landingPage/article_4.jpeg',
                    title: '飛豬管家，物管公司分享產品使用心得',
                    tags: ['找房','物業管理','管家','租屋','租房','包租代管'],
                    content: ['台灣節節高升的房價，使得越來越多人購屋無望轉買為租，租屋已經成為了一種趨勢。租賃市場需求擴大，眾多的包租代管公司如雨後春筍般的成立，系統管理的需求也迫切產生。','飛豬管家在2021年2月推出企業版，已有好幾家物業管理公司進行合作，這次特別訪談到了在不動產租賃市場有10幾年經驗，從一開始管理20間房源到現在管理幾百間房源的皇嘉物業管理顧問股份有限公司、負責人楊晴惠，使用這套租賃管理系統後的心得分享：','飛豬管家：是什麼原因讓您想導入飛豬管家企業系統', '負責人：原本作業有太多重複性的工作，需要花費很多時間跟人力，希望有一套更有效率的系統來減少人工作業跟減少錯誤，讓員工的價値，發揮在核心業務上，為公司創造業績，將心力放在提供房客或屋主更好的服務，才有可能提升產業整體價値。','Q市面上不乏相似的產品，選擇飛豬管家的理由是什麼？', 'A 比較過幾個提供類似服務的平台，發現飛豬管家有租客專屬的找房APP，且可以免費刊登廣告。提供的功能比較全面且貼近物管公司需求。除了一般常見的房源跟帳務報表、線上簽立電子合約等功能之外，還有自動產生屋主對帳單跟委託房客的功能。','Q剛開始使用時，有遇到什麼困難嗎？', 'A 因為過去從來沒有使用過類似的系統，且功能還不熟悉，一開始公司同仁在使用時有點抗性，但在經過一段時間的了解跟摸索過後，現在同仁已經滿依賴使用飛豬管家，把節省的時間用來處理其他事情。','Q 在合約與租約管理上跟以往有很大的差異嗎？', 'A 在租客訂房，可以瀏覽預訂房客的評價，大大提升租房成功率跟後續的管理容易度。不只進行中的租約很方便管理，就連已結束的租約記錄也清楚記載，減少人工及紙本作業翻找過往的記錄，除了便利外，飛豬管家也提供數據統計跟報表分析，同時與同行做出區別。','Q 目前覺得最好用的功能是哪一項？', 'A 其實每項功能對於原先傳統方式皆須要人工作業來說方便許多，像是自動新增電子帳單，線上催繳，現在都是飛豬管家自動處理的，相對以往光是每月製作跟寄發紙本帳單，還有電話催繳，人力就節省很多。加上每月自動產生屋主對帳單，更是大幅減少行政作業人力跟錯誤率。最重要的是委託房客這個功能，可以提前出租，降低業務帶看工作量的同時還能降低空房率是很値得推薦的創新功能。']
                },
                {
                    id: 3,
                    cover: 'https://flypig-public.s3-ap-southeast-1.amazonaws.com/images/landingPage/article_3.jpeg',
                    title: '簡單三步驟，避免租房後才發現隔音差的問題',
                    tags: ['租屋', '房東', '房客', '隔間', '租房'],
                    content: ['在外租屋族不僅只怕遇到惡房東和惡鄰居，還怕遇到爛隔間，入住後才發現房間隔音有問題，當滿心歡喜的迎接新的住處，進駐後第一晚，一切的美好就立刻結束，隔壁房客的講話聲、音樂聲甚至打呼聲都聽得一清二楚，這時真不知道該怎麼辦，搬走也不是跟房東說也不是，也不想第一晚就跟隔壁房客結下惡緣，只能忍耐到租約到期後搬走。如何避免當冤大頭呢？只要簡單的幾個步驟就可以。', '第一步，在你看房時，用手指頭敲敲四面牆壁，輕輕的叩叩兩聲就可以知道答案，若是聽起來空空虛的像是在敲紙箱，那就要有心理準備，這間房間隔音一定不好，入住後一定不得安寧。現在有許多房東裝修租屋處時喜歡選擇輕隔板來做隔間，從中降低裝修成本，但比起厚實的水泥牆面，這間看似獨立的空間，其實完全沒有隔音的效果，因此敲敲牆壁變成你看房時得做的一件事。', '但現在想要在外租屋，打開租屋網站，多的是隔間套房或雅房，相對水泥牆的房間租金也較低廉，若有預算上的考量，哪有那麼容易避免，這時第二步就要事先與房東了解隔壁房客型態。每個人對於聲音的接受程度不同，當夜深人靜的時候，再細微的聲音都可以被嫌吵，無論是講話聲、電視聲或音樂聲，尤其又是最可怕的低頻率稀疏聲，事先與房東多問一句，了解隔壁房客的型態，也可以多一個思考層面決定是否要簽約租房。', '最後一步則是四周看看水管線，有些房東在降低裝修成本時會選擇現在流行的工業風格，也就是將水管線外露在房間中，如果只有自己的一條水管還好，最怕的是剛好租到水管匯集區，所有的水都從你這間分流出去，其他房間無論是開水關水或沖馬桶，你這間房間都可以聽到流水聲，這時若又遇到晚洗澡的房客，一整晚就聽著流水聲到天亮，因此環顧一下四周，也能降低變成租房冤大頭的風險。']
                },
                {
                    id: 2,
                    cover: 'https://flypig-public.s3-ap-southeast-1.amazonaws.com/images/landingPage/article_2.jpeg',
                    title: '房東們請自保，避免惡房客',
                    tags: ['租金', '房東', '房租', '租約', '租屋', '欠款', '房客'],
                    content: ['這年頭，房客找好房東難、房東找好房客更難。前陣子發生於屏東的美女租客3個月毀套房事件，讓全台房東心有餘悸，過去總有些房東偏好租給女生，殊不知知人知面不知心，美女房客看起來真無害，可怕的是關起門來生活習慣嚇死人，不但將房子弄的髒亂不堪且滿地垃圾、馬桶黃漬不刷、貓屎不清，可惡的是還積拖房租欠款，等到房東提告態度還極惡劣，搞得房東房子毀了，還得花時間與這名女房客周旋，真的也只能自認倒霉的承受一切。', '近年在居住正義大旗下，保障房客的法規越來越多，反而是房東缺乏發聲與保障管道，可惜的是除非房東本是神機妙算劉伯溫，不然很容易遇到那些破壞房屋、欠款房租、拒絕搬遷的惡房客，在這種無法真穿透人心地了解房客之時，我們列出幾項方法，讓房東們在簽租約前多一份安心，而不再只是靠運氣選房客。', '避免破壞房屋者：看房時的交談與行為觀察', '看房過程中要多與客人交談，觀察其行為舉止是否有不妥之處，房東可以要求房客提供良民證，若是急著入住的房客也要多留意，背後八成都有麻煩的故事。大多房東也擔心會租到有暴力傾向的房客，現在手機有開放下載警政服務app，裡面有治安項目可查捕逃犯的功能，只要輸入身分證字號與姓名，就能知道是否遭通緝，如此一來房東就能避免將房子租給不適當的人。', '避免積脫房租欠款者：簽租約前的身家背景調查', '在尚未見面時，房東可以從電話中進行簡單的身家調查，簡單詢問租屋需求以及工作單位等，初步了解房客的狀況，作為預約看房的前奏。後續也可以請房客提供工作證明或薪資證明，以避免收入不穩定的房客欠款房租。倘若真的遇到欠款房租者，房東們記得適當地進行催繳並留下其訊息通知，房東可以先從兩個月押金中扣抵房租欠款，若欠款租金達四個月，則要對房客寄送存證信函要求房客付租金，以維護自身權益。', '避免拒絕搬遷者：發送二次存證信函通知租約終止', '若房客持續不付租金，房東可以開始著手要求房客搬離租屋處，但房東切記千萬別自己擅自進入屋內，因為很有可能會觸犯強制罪、侵入住居罪，甚至遭反告竊盜及毀損罪，真正合法有效的方法是再次寄送存證信函，清楚表示租約終止日，若房客為於期限內搬離，房東可以到各縣市地方法院提出民事訴訟，要求房客返還房屋及繳清欠款，透過強制執行讓房客遷出。']
                },
                {
                    id: 1,
                    cover: 'https://flypig-public.s3-ap-southeast-1.amazonaws.com/images/landingPage/article_1.jpg',
                    title: '找人合租房，你想好了嗎？',
                    tags: ['房東', '房客', '合租', '租屋', '套房', '房租'],
                    content: ['房價貴鬆鬆，租房的人越來越多，隨之租金也悄悄地跟著成長，在租客負擔不起高租金又想享有好的住屋品質下，越來越多租客選擇找人合租房，從中減輕房租帶來的負擔。但找人合租前，房租分攤問題、公共費用及公共空間維護問題這些你都想過了嗎？最怕那種曾經是好朋友，合租房後變成老死不相往來的陌生人，撇開你的租金減低了，這些眉眉角角真的能讓你有好的居住品質嗎？因此，合租房前提醒你先做好以下的準備。', '房租的分攤', '房租要如何分攤，有些共用衛浴、有些是獨立套房、有些是雙人房、有些是單人房，是要依照房間大小還是均分費用，又或者是按照人頭數算，這些都會影響未來租金的繳交，無論是哪種分攤方式，都建議租客們在事前先與未來的室友討論清楚，避免未來再繳交房租時出現問題。', '公共費用的分攤', '多數合租房都不會裝設獨立電錶，水費及瓦斯費皆為共用，但偏偏每個人的生活習慣不同，用量也不同，有些人喜歡在家開伙、有些人洗澡時間較長、有些人不吹冷氣睡不著，這些問題要如何解決，如何公平分攤這些公共費用，建議要在事前先說清楚，以免未來遇到大家使用量不同，心中產生不平衡的疙瘩出現。', '公共空間的維護', '找人合租房優點之一就是擁有較大的公共活動空間，偏偏公共空間的維護就像學校的公共區域需要有人打掃，小至倒垃圾、大至廁所清掃，就像值日生輪職表一樣，可訂定出一份打掃公約，明確規劃公共區域的整潔如何維護。', '上述列出幾項合租房前的注意事項，最後還要再提醒所有合租客，過去合租房簽訂租約時，為省去麻煩，房東多只會與一位主要承租人簽署租約，這樣的方式仍會出現許多小糾紛，房客們可以嘗試與房東討論是否每一位房客分別獨立簽署租約，清楚地將上述事項做一個記載，以免未來問題發生後找不到責任歸屬人。']
                }
            ]
        }
    },
    methods: {
    }
}
</script>
<style lang="scss" scoped>
.article {
    margin-bottom: 40px;
    .article-wrap {
        .container {
            width: 911px;
            margin-left: auto;
            margin-right: auto;
            box-sizing: border-box;
        }
        .banner {
            position: relative;
            margin-bottom: 50px;
            height: 400px;
            width: 100%;
            background-image: url('https://flypig-public.s3-ap-southeast-1.amazonaws.com/images/landingPage/article.png');
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;

            .title {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                font-size: 54px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                color: #ffffff;
            }
        }
        .article-list {
        }
    }
}

@media screen and (max-width: 1100px){
    .article {
        .article-wrap {
            .banner {
                height: 198px;
                margin-bottom: 14px;

                .title {
                    font-size: 24px;
                }
            }
            .article-list {
                padding: unset;
                width: unset;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/officailPage/article/article.vue